/* file description */
import React, { useState, FC, useEffect, useRef } from 'react';
import { Button, ImageViewer, Mask, Image, Popup, SpinLoading } from 'antd-mobile';
import styles from './index.module.less';
import { useAsyncEffect } from 'ahooks';
import { getPicInfo } from '@/api/tools';
import useMetaStore from '@/store/useMetaStore';
// import { fieldRealiton, mockData, fileRelation } from './relationMock';
import { BtnInfoType } from '../../sp-business-btn';
import card from './card.png';
import { Typography } from 'antd';

const { Title, Paragraph, Text, Link } = Typography;

interface WithContentProps {
  visible: boolean;
  setVisible: (val: boolean) => void;
  btnInfo: BtnInfoType;
}


export const WithContent: FC<WithContentProps> = ({
  visible,
  setVisible,
  btnInfo,
}) => {
  const cameraFileRef = useRef();
  const loadFileRef = useRef();
  const [loadFile, setLoadFile] = useState({
    createImgUrl: '',
    file: null,
  });
  const [loading, setLoading] = useState(false);

  const { utils } = useMetaStore();

  const cameraChange = () => {
    const curFile: any = cameraFileRef.current && cameraFileRef.current.files;
    if (!curFile[0]) return;
    const url = URL.createObjectURL(curFile[0]);
    setLoadFile({
      createImgUrl: url,
      file: curFile[0],
    });
  };

  const uploadChange = () => {
    const curFile: any = loadFileRef.current && loadFileRef.current.files;
    if (!curFile[0]) return;
    const url = URL.createObjectURL(curFile[0]);
    setLoadFile({
      createImgUrl: url,
      file: curFile[0],
    });
  };

  // 单张上传正面图片
  const handleAvatarSuccess = (file: any) => {
    const formData = new FormData();
    formData.append('file', file);
    const r = new FileReader();
    r.readAsDataURL(file);
    setLoading(true);
    r.onload = function (e) {
      // formData.append('code', e.target.result);
      getPicInfo(formData).then((res) => {
        console.log(res, '解析的名片值');
        setLoading(false);
        setVisible(false);
        jumping({ data: res.data, btnInfo });
      });
    };
  };

  const jumping = ({ data, btnInfo }) => {
    const { pageId, fieldRelation: FieldRe, fileRelation: FileRe } = btnInfo;
    let fieldRelation: any = [];
    try {
      fieldRelation = JSON.parse(FieldRe || '[]');
    } catch (e) {
      console.error(`${e}---------字符串解析失败`);
    }
    const btKeys = Object.keys(data?.words_result || {});
    const obj: Record<string, any> = {};

    fieldRelation.forEach((re) => {
      if (!obj[re.targetModule]) {
        obj[re.targetModule] = {};
      }
      re.relation.forEach((item) => {
        if (btKeys.includes(item.source?.name)) {
          obj[re.targetModule][item.target.name] = data?.words_result?.[item.source?.name][0];
        } else {
          obj[re.targetModule][item.target.name] = data?.[item.source?.name];
        }
      });
    });

    Object.keys(obj).forEach((moduleCode) => {
      const isRow = fieldRelation.find((re) => re.targetModule === moduleCode)?.type === 'row';
      if (isRow) {
        obj[moduleCode] = [obj[moduleCode]];
      }
    });

    utils.buiNavigate({
      type: 'tab',
      path: `/lcp/task/${pageId}/create?TAB_KEY=${new Date().getTime()}&initParams=${JSON.stringify(obj)}`,
      title: 'EIMOS',
    });
  };


  const submit = async () => {
    if (!loadFile.file) return;
    handleAvatarSuccess(loadFile.file);
  };


  return (
    <Popup
      visible={visible}
      onMaskClick={() => {
        setVisible(false);
      }}
      position="bottom"
      bodyStyle={loadFile.file ? {
        height: '50vh',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px' } : {
        height: '35vh',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
      }}
      destroyOnClose
    >
      <div className={styles['overlay-content']}>
        <div
          className={styles['option-button']}
          style={loadFile.file ? { height: '15%' } : {}}
        >
          <div className={styles['tool-btn']} style={{ zIndex: -1 }} >拍照</div>
          <input className={styles.upload} ref={cameraFileRef} type="file" accept="image/*" capture="environment" onChange={cameraChange} />
        </div>
        <div
          className={styles['option-button']}
          style={loadFile.file ? { height: '15%' } : {}}
        >
          <div className={styles['tool-btn']} style={{ zIndex: -1 }} >本地相册</div>
          <input className={styles.upload} ref={loadFileRef} type="file" accept="image/*" onChange={uploadChange} />
        </div>
        {
          loadFile.file ? (
            <Image
              className={styles['image-preview']}
              src={loadFile.createImgUrl}
              fit="fill"
              style={loadFile.file ? { height: '55%' } : {}}
            />
          ) : (
            <div className={styles['image-no-view']}>
              <div className={styles['image-tip']}>
                <Typography >
                  <Title level={5}>名片拍摄建议</Title>
                  <Paragraph>
                    将名片置于取景器中间，保持文字清晰
                  </Paragraph>
                </Typography>
              </div>
              <img src={card} />
            </div>
          )
        }
        <div
          className={styles['option-tools']}
          style={loadFile.file ? { height: '15%' } : {}}
        >
          {
            loadFile.file ? (
              <>
                <div
                  className={styles['two-btn']}
                  onClick={() => setVisible(false)}
                >取消
                </div>
                <div
                  className={styles['two-btn']}
                  style={{ color: '#0064CE' }}
                  onClick={submit}
                >确定
                </div>
              </>
            ) : (
              <div
                className={styles['one-btn']}
                onClick={() => setVisible(false)}
              >取消
              </div>
            )
          }
        </div>
        {
          loading && (
            <div className={styles.loading}>
              <SpinLoading color="primary" style={{ '--size': '48px' }} />
            </div>
          )
        }
      </div>
    </Popup>
  );
};

